import React, { Component } from "react";
import defaultWoman from "../../images/defaultWoman.png";
import "./ResultItem.css";
import AddCommand from "../Commands/AddCommand/AddCommand";
import DotCommand from "../Commands/DotCommand/DotCommand";
import ExpandCommand from "../Commands/ExpandCommand/ExpandCommand";
import CloseCommand from "../Commands/CloseCommand/CloseCommand";
import CollapseCommand from "../Commands/CollapseCommand/CollapseCommand";
import ReduceCommand from "../Commands/ReduceCommand/ReduceCommand";
import FavoryCommand from "../Commands/FavoryCommand/FavoryCommand";

class ResultItem extends Component {
  state = {
    menuItems: [
      {
        id: "0",
        icone: "",
        item: "Ajouter",
        value: "",
        addSep: false,
        sep: "0",
      },
      {
        id: "1",
        icone: "",
        item: "Modifier",
        value: "",
        isNested: "",
        addSep: false,
      },
      {
        id: "2",
        icone: "",
        item: "Supprimer",
        value: "",
        isNested: "",
        addSep: true,
      },
    ],
  };
  render() {
    return (
      <div className="result-items">
        <div>
          <div className="title">
            <a>
              <h4>How to comment in React JSX - Wes Bos</h4>
            </a>
          </div>
          <div className="favory">
            <FavoryCommand checked={false} color="#008dff"></FavoryCommand>
          </div>
        </div>
        <div className="subTitle">
          <span className="vertical-bar">Amazon</span>
          <span className="vertical-bar">Toronto, ON</span>
          <span>Posted 23 hours ago</span>
        </div>

        <div>
          <span className="description">
            Aug 25, 2015 · Kind of a pain, but React devs has stated they do not
            plan to add regular JS commenting to JSX. If you use Sublime Text,
          </span>
          <div className="endDescription">
            <span>Sponsored</span>
          </div>
        </div>
      </div>
    );
  }
}

export default ResultItem;
